

export default class Controller {

    constructor() {
        $( () => {
            this.ready();
        });
    }

    ready() {
    }
}